import { render } from "./labMaster.vue?vue&type=template&id=46ad2376&scoped=true"
import script from "./labMaster.js?vue&type=script&lang=js"
export * from "./labMaster.js?vue&type=script&lang=js"

import "./labMaster.vue?vue&type=style&index=0&id=46ad2376&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ad2376"]])

export default __exports__